module.exports = __webpack_public_path__ + "img/17_54.f8bce0b6.png";